<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title :class="{ 'hidden-sm-and-down': showSearch }">
        {{
          $route.name.includes('training.resources')
            ? 'Student Leader Training Resources'
            : 'Lunchtime Group Resources'
        }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        class="mx-4"
        color="primary"
        @click="setOrder"
        :loading="settingOrder"
      >
        Save Order
      </v-btn>
      <v-btn
        :to="{
          name: $route.name.includes('training.resources')
            ? 'training.resources.create'
            : 'resources.create'
        }"
        color="primary"
        >Add new resources</v-btn
      >
    </v-app-bar>
    <div class="ma-4" id="resources-list">
      <template>
        <v-row>
          <v-col cols="auto" class="mt-2">
            <v-btn block color="primary" @click.stop="showCategoryDialog = true"
              ><v-icon>mdi-plus</v-icon></v-btn
            >
          </v-col>
          <v-col cols="12" md="10">
            <v-tabs v-model="tab" hide-slider>
              <draggable
                :list="resourceCategories.data"
                class="row draggable"
                :sort="true"
                group="one"
                animation="100"
              >
                <v-tab
                  v-for="category in resourceCategories.data"
                  :key="category.id"
                  :href="`#tab-${category.id}`"
                >
                  {{ category.name }}
                </v-tab>
              </draggable>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="category in resourceCategories.data"
                :key="category.id"
                :value="`tab-${category.id}`"
              >
                <draggable
                  :list="category.resources"
                  class="row my-5 draggable"
                  :sort="true"
                  group="one"
                  ghost-class="ghost"
                  animation="100"
                >
                  <v-col
                    cols="4"
                    :key="resource.id"
                    v-for="resource in category.resources"
                  >
                    <v-card>
                      <v-img height="250" :src="resource.cover.url"></v-img>
                      <v-card-title>
                        <div class="resourceTitle">{{ resource.title }}</div>
                      </v-card-title>
                      <v-card-text>
                        <div style="min-height: 70px">
                          {{ resource.subtitle }}
                        </div>
                      </v-card-text>
                      <v-card-actions>
                        <v-list-item class="grow">
                          <v-list-item-avatar color="grey darken-3">
                            <v-img
                              class="elevation-6"
                              :src="resource.created_by.avatar_url"
                            ></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ resource.created_by.full_name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ resource.createdAt }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-row align="center" justify="end">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="view(resource)"
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                >
                                  <v-icon>mdi-eye</v-icon>
                                </v-btn>
                              </template>
                              <span>View Resource</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="edit(resource)"
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                >
                                  <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                              </template>
                              <span>Edit Resource</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="archive(resource)"
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                >
                                  <v-icon>mdi-archive</v-icon>
                                </v-btn>
                              </template>
                              <span>Archive Resource</span>
                            </v-tooltip>
                            <v-tooltip v-if="resource.count_bookmarks > 0" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="showUsers(resource)"
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  class="mr-4"
                                >
                                  <v-badge
                                    top
                                    color="primary"
                                    overlap
                                    :content="resource.count_bookmarks"
                                    offset-x="15"
                                    offset-y="10"
                                  >
                                    <template #badge>{{
                                      resource.count_bookmarks
                                    }}</template>
                                    <v-icon>mdi-bookmark</v-icon>
                                  </v-badge>
                                </v-btn>
                              </template>
                              <span>See list of users</span>
                            </v-tooltip>
                          </v-row>
                        </v-list-item>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </draggable>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-col cols="auto">
            <v-menu>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="editSelectedCategory(selectedCategory)">
                  <v-list-item-title>Edit selected Category</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteSelectedCategory(selectedCategory)">
                  <v-list-item-title
                    >Delete selected Category</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </template>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <bookmark-dialog
        :resource="selectedResouce"
        v-model="showBookmarksDialog"
      />
      <category-dialog
        :open="showCategoryDialog"
        :category="selectedCategory"
        :editing="editing"
        @close="closeCategoryDialog"
        @success="showToast('Category successfully added', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mdiDotsVertical, mdiMagnify } from '@mdi/js'
import debounce from 'lodash/debounce'
// import TextHighlight from 'vue-text-highlight'
import ResourceCategory from '@/models/ResourceCategory'
import env from '@/services/env'
import * as ResourceType from '@/utils/consts/ResourceType'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import draggable from 'vuedraggable'
import BookmarkDialog from '@/components/modals/Bookmark'
import CategoryDialog from '@/components/modals/Category'

export default {
  name: 'ResourcesPage',

  components: {
    // TextHighlight,
    AppBarNavIcon,
    draggable,
    BookmarkDialog,
    CategoryDialog
  },

  data() {
    return {
      drag: false,
      tab: null,
      loading: false,
      loadingCategories: false,
      settingOrder: false,
      showSearch: false,
      showBookmarksDialog: false,
      showCategoryDialog: false,
      editing: false,
      filter: {
        search: ''
      },
      icons: {
        settings: mdiDotsVertical,
        search: mdiMagnify
      },
      selectedResouce: null,
      resourceCategories: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  computed: {
    paginationLength() {
      return this.resourceCategories.meta.last_page
    },

    selectedCategory() {
      if (!this.tab) return null
      const id = this.tab.split('-')[1]
      return this.resourceCategories.data.find(item => item.id === parseInt(id))
    },

    selectedCategoryHasResource() {
      return this.selectedCategory && this.selectedCategory.resources.length > 0
    }
  },

  methods: {
    getCategories() {
      this.loadingCategories = true
      return ResourceCategory.include(
        'resources',
        'resources.cover',
        'resources.created_by',
        'resources.allBookmarks'
      )
        .where(
          'type',
          this.$route.name.includes('training.resources')
            ? ResourceType.TRAINING
            : ResourceType.LTG
        )
        .page(parseInt(this.resourceCategories.meta.current_page))
        .limit(9999)
        .get()
        .then(response => {
          this.resourceCategories = response
          this.tab = null
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },

    pageChanged(page) {
      this.resourceCategories.meta.current_page = page
      this.getCategories()
    },

    search: debounce(function() {
      this.getCategories()
    }, 600),

    view(resource) {
      window.open(`${env.appUrl}/resources/${resource.slug}`)
    },

    edit(resource) {
      this.$router.push({
        name: this.$route.name.includes('training.resources')
          ? 'training.resources.edit'
          : 'resources.edit',
        params: { id: resource.slug }
      })
    },

    archive(resource) {
      this.$confirm(
        `Are you sure you want to archive this resource "${resource.title}"?`,
        {
          color: 'primary',
          title: 'Archive Group Resource'
        }
      ).then(confirm => {
        if (confirm) {
          resource.delete().then(response => {
            this.resourceCategories.meta.current_page = 1
            this.getCategories()
            this.$toast('Group Resource successfully deleted!', {
              color: 'green'
            })
          })
        }
      })
    },

    showUsers(resource) {
      this.showBookmarksDialog = true
      this.selectedResouce = resource
    },

    setOrder() {
      this.settingOrder = true

      this.$api
        .post(`/resources/set-order-by-category`, {
          to_sort: this.resourceCategories.data.map(resource =>
            resource.resources.map(item => ({ id: item.id }))
          )
        })
        .then(response => {
          this.showSnackbar(response.data.message)
        })
        .catch(() => {
          this.$toast('Resource order successfully changed!', {
            color: 'green'
          })
        })
        .finally(() => (this.settingOrder = false))

      this.$api
        .post(`/resource-categories/set-order`, {
          to_sort: this.resourceCategories.data.map(resource => resource.id)
        })
        .then(response => {
          this.showSnackbar(response.data.message)
        })
        .catch(() => {
          this.$toast('Resource Categories order successfully changed!', {
            color: 'green'
          })
        })
        .finally(() => (this.settingOrder = false))
    },

    showToast(message, status) {
      this.getCategories()
      this.$toast(message, {
        color: !status ? 'green' : 'red'
      })
    },

    deleteSelectedCategory() {
      this.$confirm(
        `Are you sure you want to remove ${
          this.selectedCategory.name
        } Resource Category? ${
          this.selectedCategoryHasResource
            ? 'All resources in this category will be deleted.'
            : ''
        }`,
        {
          color: 'primary',
          title: 'Delete Resource Category'
        }
      ).then(confirm => {
        if (confirm && this.selectedCategory) {
          this.selectedCategory
            .delete()
            .then(() => {
              return this.getCategories()
            })
            .then(() => {
              this.$toast('Resource Category has been successfully removed!', {
                color: 'green'
              })
            })
        }
      })
    },

    editSelectedCategory() {
      this.showCategoryDialog = true
      this.editing = true
    },

    closeCategoryDialog() {
      this.showCategoryDialog = false
      this.editing = false
    }
  },

  created() {
    this.getCategories()
  },

  watch: {
    '$route.path'() {
      if (
        this.$route.name === 'resources' ||
        this.$route.name === 'training.resources'
      )
        this.getCategories()
    }
  }
}
</script>

<style scoped>
.draggable .v-card {
  cursor: move;

  &:hover,
  &:active,
  &:focus {
    cursor: move;
  }
}

.ghost {
  background: #00adcd20;
  outline: 1px dashed #00adcd;
}

.resourceTitle {
  min-height: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.resourceSubtitle {
  min-height: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
